// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1dc0681b","453":"2521bcf7","455":"8ee5fafa"}[chunkId] + ".chunk.js";
};